import React from "react";
import { Layout, Image, Row } from "antd";
import "./home.scss";
import { Carousel } from "../../Components/Carousel";
import { homePageCarouselData } from "../../mocks/homepageCarousel";
import { Industries } from "../../Sections/HomePage/Industries";
import { CustomersAndPartners } from "../../Sections/HomePage/CustomerAndPartners";
import NewTitle from "../../Components/NewTitle/NewTitle";
import SuccessStoriesNew from "../../Components/SuccessStoriesNew/SuccessStoriesNew";
import GridView from "../../assets/images/industries/industries-grid.svg";
import { Services } from "../../Components/OurServices";
import { ProductIntroducton } from "../../Components/ProductIntroduction";
import ProductSection from "../../Sections/HomePage/ProductSection/ProductSection";
import { HomeBanner } from "../../Components/HomeBanner";
import SuccessStoriesScroll from "../../Components/SucessStoriesScroll/SucessStoriesScroll";

import bg from "../../assets/images/successStories1/bg.png";
import sentiments from "../../assets/images/successStories1/sentiments.png";
import realtime from "../../assets/images/successStories1/realtime.png"
import backofficee from "../../assets/images/successStories1/backofficee.png"
import liabilities from "../../assets/images/successStories1/liability.png"
import real_time from "../../assets/images/successStories1/real-time.png"
import modern from "../../assets/images/successStories1/modern.png"
import digital from "../../assets/images/successStories1/digital.png"
import lake from "../../assets/images/successStories1/lake.png"
import enterprise from "../../assets/images/successStories1/enterprise.png"
import detec from "../../assets/images/successStories1/detec.png"


const Home: React.FC = () => {
  const servicedata = [
    {
      heading: "Enterprise Data Modernization",
      heading1:
        "Transform your legacy platforms to contemporary data platforms. We",
      heading2:
        "enable enterprises to create the single version of truth for intelligent insights.",
      className1: "serviceContainer_servicesText",
      className2: "serviceContainer_servicesSubText",
      link: "/edm",
    },
    {
      heading: "Big-Data Advisory & Engineering",
      heading1:
        "Build an enterprise Data Lake to fuel innovation and unleash big data ",
      heading2: "potential",

      className1: "serviceContainer_servicesTextBigData",
      className2: "serviceContainer_servicesSubTextBigData",
      link: "/bigData",
    },
    {
      heading: "AI, ML & Analytics",
      heading1:
        "Craft a 'Blue Ocean Strategy' to propel your business with leading-edge data",
      heading2: "science, AI and advanced analytics",
      className1: "serviceContainer_servicesTextAnalytics",
      className2: "serviceContainer_servicesSubTextAnalytics",
      link: "/analytics",
    },

    {
      heading: "Enterprise Cloud Solutions",
      heading1:
        "Boost business results, cut operational costs, and maximize innovation with",
      heading2: " Cloud Adoption",
      className1: "serviceContainer_servicesTextCloud",
      className2: "serviceContainer_servicesSubTextCloud",
      link: "/cloud",
    },
    {
      heading: "Enterprise Automation",
      heading1:
        "Our RPA solutions empower enterprises to dramatically reduce costs and",
      heading2: "boost efficiency, productivity, and performance.",
      className1: "serviceContainer_servicesTextEnterprise",
      className2: "serviceContainer_servicesSubTextEnterprise",
      link: "/auto",
    },
    {
      heading: "CRM and ERP",
      heading1:
        "We craft CRM and ERP solutions that seamlessly unite companies and",
      heading2: " customers in intuitive engagements.",
      className1: "serviceContainer_servicesTextCRM",
      className2: "serviceContainer_servicesSubTextCRM",
      link: "/ui",
    },
  ];

  const sucessStories = [
    {
      src: real_time,
      info: "Real-time insights and recommendation engine for one of the largest pharmaceuticals company..",
      route: "/overview?type=realtime",
    },
    {
      src: bg,
      info: "Big-Data lake setup on Azure cloud for top 3 pet retailers in the world",
      route: "/overview?type=bigdata",
    },
    {
      src: sentiments,
      info: "Real-time insights and recommendation engine for one of the largest pharmaceuticals company..",
      route: "/overview?type=sentiment",
    },
    {
      src: modern,
      info: "Enterprise Data Modernization of one of world’s largest credit card company from Teradata to..",
      route: "/overview?type=modernization",
    },
    {
      src: detec,
      info: "Detection to Intent to Fraud using NPL for one of world’s largest banks",
      route: "/overview?type=detection",
    },
    {
      src: liabilities,
      info: "Modernization of Enterprise reporting (Netezza) to AWS for a major housing finance company",
      route: "/overview?type=newLiability",
    },
    {
      src: backofficee,
      info: "Back Office RPA Solution for American Multinational investment",
      route: "/overview?type=backOffice",
    },
    {
      src: digital,
      info: "Digital Transformation for one of the largest oil and Gas company in the world.",
      route: "/overview?type=digitalTransformation",
    },
    {
      src: realtime,
      info: "Realtime anomaly detection & network monitoring for major telecommunications company in USA.",
      route: "/overview?type=realtimeAnomaly",
    },
    {
      src: lake,
      info: "End-to-End Data Lake Setup & Migration of Netezza reporting platform to Azure for a Major retailer",
      route: "/overview?type=datalake",
    },
    {
      src: enterprise,
      info: "Create new liability insurance models based on IOT sensor data for a leading business Insurer.",
      route: "/overview?type=enterprise",
    },
    
  ];

  return (
    <Layout style={{ background: "#1D1A36" }}>
      {/* <HomeBanner /> */}
      <Carousel data={homePageCarouselData} />
      <ProductSection />
      <ProductIntroducton />

      <Services servicedata={servicedata} />
      <Row className="grid-row" align={"middle"} justify={"center"}>
        <Industries />
        <h1 className="ocp-main-title" style={{ marginBottom: "0rem" }}>
          SUCCESS STORIES
        </h1>
        <div className="grid-div">
          <Image src={GridView} alt="GridView" preview={false} />
        </div>
      </Row>
      {/* <Row> */}
        {/* <SuccessStoriesNew /> */}
        <SuccessStoriesScroll
        sucessStories={sucessStories}
        onCardClick={(e) => {
          console.log("oncard", e);
        }}
      />
      {/* </Row> */}
      <CustomersAndPartners />
    </Layout>
  );
};

export default Home;
